import type { SaferGamblingConfig } from '../../saferGambling.types.ts';
import { ROUTES } from './routes/routes.ts';

const SAFER_GAMBLING: SaferGamblingConfig = {
  showRealityCheck: false,
  depositLimitsRequireAcceptance: false,
  depositLimitAmountMax: { DAY: 5000, WEEK: 10000, MONTH: 30000 },
  showBreakToolsNotSetStatus: true,
  preselectBreakToolPeriod: false,
  disableBreakToolConfirmUntilValid: true,
  resetBreakToolFormOnClose: true,
  breakToolConfirmation: {
    enabled: true,
    supportTeamHref: 'https://kenogo.custhelp.com/app/ask',
  },
  coolOffUnit: 'days',
  coolOffFallback: 7,
  coolOffStatusKeys: {
    pendingRaise: 'pending_raise_7d',
    pendingRemoval: 'pending_removal_7d',
  },
  depositLimitStatusIndicatorColor: 'hsl(var(--info-foreground))',
  learnMoreHref: ROUTES.FOOTER.NAVIGATION.LEGAL.GAMBLE_SAFELY,
  otherResources: [
    {
      translationKey: 'gamblers_help',
      href: ROUTES.FOOTER.RESPONSIBLE_GAMING.GAMBLERS_HELP,
      trackName: 'Gamblers Help',
    },
    {
      translationKey: 'reset_app',
      href: ROUTES.FOOTER.RESPONSIBLE_GAMING.RESET_APP,
      trackName: 'Reset',
    },
  ],
  timeOutPeriods: ['P1D', 'P1W', 'P1M', 'P6W'],
  timeOutPeriodLabelKeys: {
    P1D: '24_hours',
    P1W: '1_week',
    P1M: '1_month',
    P6W: '6_weeks',
  },
  selfExclusionPeriods: ['P6M', 'P9M', 'P1Y', 'P2Y', 'P5Y', 'P2147483647Y'],
};

export { SAFER_GAMBLING };
